var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isEmpty
    ? _c(
        "div",
        {
          staticClass: "field-container",
          class: { "df-error": _vm.error, "field-disabled": _vm.disabled }
        },
        [
          _c("span", {
            staticClass: "field-label",
            domProps: { innerHTML: _vm._s(_vm.text) }
          }),
          _vm._v(" "),
          _vm.button
            ? _c("span", { staticClass: "field-button" }, [
                !_vm.buttonOn
                  ? _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            return _vm.change(true)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.button.off))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.buttonOn
                  ? _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            return _vm.change(false)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.button.on))]
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }